<template>
  <div>
    <div class="w-full pb-4 xl:pb-8">
      <Navigation :step="1" />

      <div class="w-full">
        <div class="container">
          <div class="text-sm xl:text-xl">
            <h1 class="pb-3 text-lg font-medium leading-tight xl:text-4xl xl:pb-4">
              {{ $t('pages.home.title') }}
            </h1>
            <p class="leading-tight">
              {{ $t('pages.home.subtitle') }}
            </p>
            <p class="pt-3 leading-tight">
              {{ $t('pages.home.multi_voucher_text', { maxVouchers }) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Form />
  </div>
</template>

<script lang="ts">
import Home from '~psp-pages/base/home/home.ts'

import Navigation from '~app/psp/austrian/navigation.vue'
import Form from './form.vue'

export default Home.extend({
  components: {
    Navigation,
    Form,
  },
})
</script>
